<template>
  <div class="landing-page">
    <SlideShow />
    <div class="banner-one">
      <div class="burger-menu">
        <span :style="{ fontSize: fontSize + 'px' }" ref="dynamicText">{{
          icm.name
        }}</span>
        <BurgerFloatButton @click="handleButtonClick" />
        <div id="burger-float-btn" v-show="isScrollingDown">
          <BurgerFloatButton @click="handleButtonClick" />
        </div>
        <div class="lines">
          <img src="@/assets/images/ZigzagLine.svg" class="line-img" />
          <img src="@/assets/images/arrow.svg" class="arrow-img" />
        </div>
      </div>
    </div>

    <div class="banner-two speedee-bold">New!</div>
    <SlideShowFeature />
    <div class="arch-animate">
      <ArchAnimationComponent />
    </div>
    <div class="banner-two speedee-bold">Discover</div>
    <div class="discover-container">
      <div id="discover" class="card-container">
        <div
          v-for="(image, index) in discover_images"
          :key="image.id"
          :class="['card', index % 2 === 0 ? 'left' : 'right']"
        >
          <div class="card-content">
            <div class="image-container">
              <img :src="image.image_url" alt="Card Image" class="card-img" />
            </div>
            <div class="card-desc">
              <h1>{{ image.title }}</h1>
              <p>
                {{ image.description }}
              </p>
              <div class="read-more">
                <img
                  src="@/assets/icons/Button.svg"
                  alt="button"
                  style="width: 100%"
                />
                <a :href="image.url" class="text-white">{{ image.button ? image.button : "More" }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BurgerMenu :isOpen="isMenuOpen" @close-overlay="handleButtonClick" />
    <WorkWithUs />
  </div>
</template>
  
<script>
import titleMixin from "@/mixins/TitleMixins.js";
import SlideShow from "./SlideShow.vue";
import SlideShowFeature from "./SlideShowFeature.vue";
import WorkWithUs from "./WorkWithUs.vue";
import BurgerFloatButton from "../../components/BurgerFloatButton.vue";
import ArchAnimationComponent from "../../components/ArchAnimationComponent.vue";
import BurgerMenu from "./BurgerMenu.vue";
import axios from "axios";

export default {
  name: "home-view",
  mixins: [titleMixin],
  components: {
    SlideShow,
    SlideShowFeature,
    WorkWithUs,
    BurgerFloatButton,
    ArchAnimationComponent,
    BurgerMenu,
  },

  data() {
    return {
      discover_images: [],
      isScrollingDown: false,
      isMenuOpen: false,
      icm: {},
      fontSize: 40,
    };
  },

  watch: {
    "icm.name": {
      handler: "adjustFontSize",
      immediate: true,
    },
  },

  mounted() {
    this.loadDiscovers();
    this.loadIcm();
    this.adjustFontSize();
    window.addEventListener("resize", this.adjustFontSize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.adjustFontSize);
  },

  methods: {
    loadDiscovers() {
      let preview = this.$route.query.preview ? this.$route.query.preview : 0;

      axios.get("/discovers/main?preview=" + preview).then((response) => {
        this.discover_images = response.data.data;
      });
    },

    loadIcm() {
      let preview = this.$route.query.preview ? this.$route.query.preview : 0;
      axios.get("/banners/home/main?preview=" + preview).then((response) => {
        this.icm = response.data.data.icm;
      });
    },

    handleButtonClick() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    adjustFontSize() {
      this.$nextTick(() => {
        const span = this.$refs.dynamicText;
        if (!span || !span.parentElement) return;

        const containerWidth = span.parentElement.offsetWidth;
        const containerHeight = span.parentElement.offsetHeight;

        // Define base and min sizes
        let fontSize = Math.min(40, window.innerWidth * 0.06); // Start responsive size
        const minFontSize = 14;

        span.style.fontSize = fontSize + "px";

        // Reduce font size until it fits the container
        while (
          (span.scrollWidth > containerWidth ||
            span.scrollHeight > containerHeight) &&
          fontSize > minFontSize
        ) {
          fontSize -= 1;
          span.style.fontSize = fontSize + "px";
        }

        this.fontSize = fontSize;
      });
    },
  },
};
</script>



<style scoped>

/* Core Layout */
.landing-page {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.card {
  border: none !important;
  background-color: transparent !important;
}

.text-span {
  color: #ffbc0d;
}

/* ===== Banner One ===== */
.banner-one {
  background: transparent url("@/assets/images/home/red_banner_home.svg")
    no-repeat center;
  background-size: cover;
  font-size: calc(0px + 3vw);
  font-weight: bold;
  text-align: center;
  padding: 1px;
  margin: -30px;
  color: white;
  z-index: 10000;
  height: 170px;
}

/* ===== Banner Two ===== */
.banner-two {
  margin-top: 80px;
  font-size: clamp(30px, 6vw, 80px);
  font-weight: bold;
  text-align: center;
  color: #db0007;
}

/* ===== Burger Menu ===== */
.burger-menu {
  text-align: center;
  width: 100%;
  max-width: 700px;
  height: 20vh;
  margin: 30px auto 1.5em;
  font-size: 3vw;
  white-space: nowrap;
  position: relative;
}

#burger-float-btn .burger-icon.burger-fixed-bottom {
  position: fixed;
  bottom: 40px;
  right: 10%;
}

/* ===== Decorative Lines ===== */
.lines {
  position: absolute;
  left: 10%;
  top: 30%;
  margin: 0 auto;
}

.line-img {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.arrow-img {
  width: 20%;
}

/* ===== Animations ===== */
.arch-animate {
  margin-left: -110px;
  margin-top: -55px;
}

/* ===== Cards ===== */
.read-more {
  position: relative;
  text-align: center;
  color: white;
  width: 270px;
  padding: 0 50px;
  margin: 0 auto;
}

.card-content {
  border-radius: 40px;
  box-shadow: 0 2px 4px rgba(129, 124, 124, 0.5);
  background-color: #fff;
  width: 100%;
}

.card-content h1,
.card-content p {
  padding: 10px 50px;
}

.card-content h1 {
  font-size: 2em;
  font-weight: bold;
}

.card-content p {
  font-size: 1.2em;
}

.card-content a {
  font-size: 1.2em;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-decoration: none;
  color: black;
  font-weight: bold;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.card.left,
.card.right {
  border-radius: 40px;
}

/* ===== Discover Section ===== */
.discover-container {
  background: transparent url("@/assets/images/discovers/discover_bg_1.png")
    no-repeat center -15px;
  background-size: cover;
  padding: 0 5vw;
  width: 100%;
  height: auto;
}

#discover .card {
  background-color: #fff;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 15px 0;
}

.image-container {
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  overflow: hidden;
}

/* ===== Responsive Breakpoints ===== */
@media (max-width: 768px) {
  /* .banner-one {
    background: transparent url("@/assets/images/home/red_banner_home.svg")
      no-repeat center;
    background-size: cover;
    font-size: calc(0px + 3vw);
    font-weight: bold;
    text-align: center;
    padding: 1px;
    margin: -30px;
    color: white;
    z-index: 10000;
    height: 170px;
  }

  .banner-two {
    font-size: 36px;
  }

  .burger-menu {
    max-width: 90%;
    font-size: 5vw;
  }

  .lines {
    top: 3vw;
  } */

  .arch-animate {
    display: none;
  }

  .card-content h1,
  .card-content p {
    padding: 10px 30px;
  }

  .card-content h1 {
    font-size: 1.6em;
  }

  .card-content p {
    font-size: 1.1em;
  }

  .read-more {
    width: 260px;
    margin: -15px auto;
  }

  #discover .card {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .banner-one {
    padding: 1rem;
    min-height: 130px;
  }

  .burger-menu {
    font-size: clamp(14px, 5vw, 20px);
    max-width: 95%;
    padding: 0.5rem;
  }

  .lines {
    max-width: 280px;
  }

  .arrow-img {
    width: 25%;
  }
}

@media (min-width: 769px) and (max-width: 1199px) {
  .banner-one {
    font-size: 2.5vw;
    padding: 30px;
    margin: -40px 0;
  }

  .banner-two {
    font-size: 50px;
  }

  .burger-menu {
    max-width: 600px;
  }

  .lines {
    left: -1%;
    top: 3vw;
  }

  .card-content h1 {
    font-size: 1.8em;
  }

  .card-content p {
    font-size: 1.2em;
  }

  #discover .card {
    width: 48%;
    margin: 20px 1%;
  }
}

@media (min-width: 1200px) {
  #discover .card {
    width: 40%;
    margin: 30px;
  }

  #discover .card.left {
    align-self: flex-start;
  }

  #discover .card.right {
    align-self: flex-end;
  }
}
</style>

  